module.exports = __webpack_public_path__ + "img/pdv2.aea642ce.svg";